import axios from "axios";
import { attributionHeader, attributionSnapshot } from "@/lib/attribution";

const BODY_ATTR = ["/payments/checkout", "/starter-kit/checkout", "/quick-plays/checkout", "/starter-kit/notify"];

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  if ((config.method || "get").toLowerCase() === "post") {
    const h = attributionHeader();
    if (h) config.headers["X-VT-Attribution"] = h;
    if (BODY_ATTR.includes(config.url) && config.data && typeof config.data === "object") {
      config.data = { ...config.data, attribution: attributionSnapshot() };
    }
  }
  return config;
});

export const signedInEmail = () =>
  api.get("/account/me", { withCredentials: true }).then((r) => r.data?.email || "").catch(() => "");

export const SLUG_TO_NAME = {
  "coaches-corner": "Coaches Corner",
  "parent-sideline": "Parent Sideline",
  "practice-plans": "Practice Plans",
};
export const NAME_TO_SLUG = {
  "Coaches Corner": "coaches-corner",
  "Parent Sideline": "parent-sideline",
  "Practice Plans": "practice-plans",
};
